import { createFileRoute } from "@tanstack/react-router";
import AdminInventoryStageSync from "@/pages/admin/AdminInventoryStageSync";

export const Route = createFileRoute("/_adminLayout/admin/inventory-stage-sync")({
  head: () => ({
    meta: [
      { title: "Ekey Inventory Sync | Rex & Sons Admin" },
      { name: "description", content: "Manage Ekey inventory pricing, stock, and LTL freight updates for Rex & Sons." },
      { property: "og:title", content: "Ekey Inventory Sync | Rex & Sons Admin" },
      { property: "og:description", content: "Manage Ekey inventory pricing, stock, and LTL freight updates for Rex & Sons." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AdminInventoryStageSync,
});
